import logo from "../assets/horizontal-logo.png";

const Home = ({onClick}) => {
  return (
    <div className="bg-black flex items-center justify-center h-screen ">
      <img 
        src={logo} 
        alt="Echo Logo" 
        className="h-32 cursor-pointer transition-transform duration-500 hover:scale-110" 
        onClick={onClick} 
      />  
    </div>
  )
}

export default Home

// import React from 'react';

// const Home = () => {
//   const colors = [
//     'bg-red-500',
//     'bg-red-400',
//     'bg-yellow-400',
//     'bg-yellow-300',
//     'bg-yellow-200',
//   ];

//   return (
//     <div className="flex space-x-[-6px]">
//       {colors.map((color, index) => (
//         <div
//           key={index}
//           className={`w-5 h-5 rounded-full ${color}`}
//           style={{ zIndex: colors.length - index }}
//         />
//       ))}
//     </div>
//   );
// };

// export default Home;
